<app-spinner [class.hide]="!loading"></app-spinner>
@if (apps?.length <= 0 && !loading) {
  <app-not-found
    [displayMessage]="message"
  ></app-not-found>
}
@for (app of apps; track app) {
  <div class="margin s5 bottom">
  <mat-card-content>
    <mat-slide-toggle
      [matTooltip]="!isUserProfileCompleted?('Incomplete_Profile_App_Message'|translate):null"
      [disabled]="!isUserProfileCompleted"
      [checked]="app.toggleState"
      color="primary"
      (change)="reset(app, $event); updatePermission()"
      >{{ app?.name }}
    </mat-slide-toggle>
  </mat-card-content>

  @if ((app.hasUserRole && app.toggleState) || (!app.hasUserRole && app.toggleState)) {
    <div class="application-access">
      @if (app?.roles?.length <= 0) {
        <div>
          {{ 'USER_DETAILS.no_roles' | translate }}
        </div>
      }
      @for (role of app?.roles; track role) {
        <div>
          <mat-checkbox
            [checked]="role.hasAccess"
            (change)="role.hasAccess = !role.hasAccess; updatePermission()"
            color="primary"
            [disabled]="!isUserProfileCompleted"
          >
            {{ role?.name }}
          </mat-checkbox>
        </div>
      }
    </div>
  }
  </div>
}
@if (_userAppsService.loading) {
  <app-spinner></app-spinner>
}
